import { Link } from "react-router-dom";

export const Overline = ({ children, className = "", light = false }) => (
  <span
    className={`amf-overline ${light ? "text-amf-gold" : "text-amf-burgundy"} ${className}`}
  >
    {children}
  </span>
);

export const Divider = ({ className = "" }) => (
  <hr className={`amf-divider ${className}`} />
);

export const SectionHeading = ({ children, className = "", light = false }) => (
  <h2
    className={`font-playfair text-3xl md:text-4xl lg:text-[2.75rem] leading-tight ${
      light ? "text-amf-cream" : "text-amf-navy"
    } ${className}`}
  >
    {children}
  </h2>
);

export const PullQuote = ({ children, by }) => (
  <blockquote className="border-l border-amf-gold pl-6 md:pl-8 my-10">
    <p className="font-playfair italic text-2xl md:text-3xl leading-snug text-amf-navy">
      <span className="text-amf-gold text-4xl leading-none mr-1 align-[-0.2em]">
        &ldquo;
      </span>
      {children}
    </p>
    {by && (
      <cite className="amf-overline not-italic text-amf-stone mt-4 block">
        {by}
      </cite>
    )}
  </blockquote>
);

const base =
  "inline-flex items-center justify-center font-inter uppercase tracking-[0.18em] text-xs md:text-sm transition-colors duration-300 px-7 py-3.5";

export const AmfButton = ({ to, href, children, variant = "solid", className = "", ...rest }) => {
  const styles =
    variant === "solid"
      ? "bg-amf-burgundy text-[var(--amf-accent-fg,#fff)] hover:bg-[var(--amf-accent-dark)]"
      : variant === "outline"
      ? "border border-amf-navy text-amf-navy hover:bg-amf-navy hover:text-amf-cream"
      : variant === "invert"
      ? "bg-amf-cream text-amf-burgundy hover:bg-amf-cream/90"
      : "border border-amf-cream/60 text-amf-cream hover:bg-amf-cream hover:text-amf-navy";
  const cls = `${base} ${styles} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
};

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`py-16 md:py-24 ${className}`}>
    <div className="max-w-[1200px] mx-auto px-6 md:px-10">{children}</div>
  </section>
);
